import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useSuppliers(query = {}) {
  return useQuery({
    queryKey: ['catalog', 'suppliers', query],
    queryFn: async () => {
      const { data } = await api.get('/catalog/suppliers', {
        params: { active: true, limit: 200, ...query }
      });
      return {
        items: data?.items || data?.data || [],
        total: data?.total || 0
      };
    },
    staleTime: 60_000
  });
}

export function useCreateSupplier() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/catalog/suppliers', body).then((r) => r.data),
    successMessage: 'تم إنشاء المورد',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['catalog', 'suppliers'] })
  });
}
